<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="2" />
      </div>
      <div class="hengtiao3">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">简历筛选</div>
      </div>
    </div>
    <div class="juzhong">
      <div class="liebiao" v-if="!isMobile">
        <div class="hengtiao1">
          <i class="el-icon-info">企业端</i>
        </div>
        <el-menu default-active="1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
          style="text-align: left;margin-left: 15%;">
          <el-menu-item index="1">
            <i class="el-icon-star-off"></i>
            <span slot="title">推荐</span>
          </el-menu-item>
          <!-- <el-menu-item index="2">
            <i class="el-icon-school"></i>
            <span slot="title">学历匹配</span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-reading"></i>
            <span slot="title">专业匹配</span>
          </el-menu-item>
          <el-menu-item index="4">
            <i class="el-icon-edit-outline"></i>
            <span slot="title">技能匹配</span>
          </el-menu-item>
          <el-menu-item index="5">
            <i class="el-icon-suitcase"></i>
            <span slot="title">经验匹配</span>
          </el-menu-item> -->
        </el-menu>
      </div>
      <div class="beijing">
        <div class="hengtiao" v-if="!isMobile">
          <div class="demo-type">
          </div>
        </div>
        <div class="head01">
          <div class="head02">简历筛选</div>
          <div style="display:flex;">
            <el-select v-model="value" placeholder="请选择" @change="handleChange">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 表格 -->
          <div style="display:flex;">
            <div class="head03">
              <el-table v-if="!isMobile" :data="displayData" stripe style=" border-radius: 20px;" v-loading="loading">
                <el-table-column label="序号" width="100">
                  <template #default="scope">
                    <div style="margin-left: 20px;">
                      {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="姓名/年龄" width="230">
                  <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                      <div class="touxiang">
                        {{ getFirstName(scope.row.userName) }}
                      </div>
                      <div style="display: flex; flex-direction: column;margin-left: 20px;">
                        <span>{{ scope.row.userName }}</span>
                        <span>{{ calculateAge(scope.row.birthday) }}岁</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column prop="degree" label="学历" width="180"></el-table-column>

                <el-table-column prop="matchLevel" label="匹配度" width="180"
                  :formatter="formatMatchLevel"></el-table-column>

                <el-table-column prop="updateTime" :formatter="formatDate" label="简历更新时间" width="170"></el-table-column>

                <el-table-column prop="star" label="是否收藏" width="150">
                  <template slot-scope="scope">
                    <el-switch v-model="scope.row.star" active-color="#13ce66" :active-value="1" :inactive-value="0"
                      @change="handleStarChange(scope.row)">
                    </el-switch>
                  </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <el-table v-else :data="displayData" stripe style="width:100%;" v-loading="loading">
                <el-table-column label="序号" width="50">
                  <template #default="scope">
                    <div style="margin-left: 0px;">
                      {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="姓名/年龄" width="150">
                  <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                      <div class="touxiang">
                        {{ getFirstName(scope.row.userName) }}
                      </div>
                      <div style="display: flex; flex-direction: column;margin-left: 20px;">
                        <span>{{ scope.row.userName }}</span>
                        <span>{{ calculateAge(scope.row.birthday) }}岁</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column prop="degree" label="学历" width="50"></el-table-column>

                <el-table-column prop="matchLevel" label="匹配度" width="80" :formatter="formatMatchLevel"></el-table-column>

                <el-table-column prop="updateTime" :formatter="formatDate" label="简历更新时间" width="110"></el-table-column>

                <el-table-column prop="star" label="是否收藏" width="80">
                  <template slot-scope="scope">
                    <el-switch v-model="scope.row.star" active-color="#13ce66" :active-value="1" :inactive-value="0"
                      @change="handleStarChange(scope.row)">
                    </el-switch>
                  </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="60">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination v-if="!isMobile" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[8]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px;"></el-pagination>
              <el-pagination v-else @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"
                style="margin-top: 20px;" small></el-pagination>
            </div>
            <div v-if="!isMobile" v-show="zhanshi" class="shuju">
              <div class="xuanzhong">选中简历</div>
              <div style="margin-left: 20px;display:flex;justify-content: left;align-items: center;margin-top:9px;">
                <div class="touxiang">
                  {{ getFirstName(jichu.userName) }}
                </div>
                <div>
                  <div>{{ jichu.userName }}</div>
                  <div style="display:flex;gap:20px;margin-top:15px;">
                    <div style="background-color: #f79e30;color:white;padding:5px;border-radius: 10px;">{{ jichu.degree }}
                    </div>
                    <div style="padding:5px;">{{ jichu.almaMater }}</div>
                  </div>
                </div>
              </div>
              <div style="margin-top: 13px;display:flex;gap:20px;align-items: center;">
                <span class="weibiaoti" style="margin-top: -1px;">专业</span>
                <div style="padding:5px">{{ jichu.major }}</div>
              </div>
              <div style="margin-top: 13px;">
                <span class="weibiaoti">证书</span>
                <span>
                  <span v-for="(cert, index) in jichu.certificate" :key="index" class="fenhang">
                    {{ cert }}
                  </span>
                </span>
              </div>
              <div>
                <div class="weibiaoti">实习经历</div>
                <span>
                  <span v-for="(ship, index) in jichu.internship" :key="index" class="fenhang">
                    {{ ship }}
                  </span>
                </span>
              </div>
              <div class="juzhong">
                <div class="selectinfo" @click="gotoQiyeReport">查看详情</div>
              </div>
            </div>
            <el-dialog :visible.sync="zhanshi" title="简历详情" v-else>
              <div class="shuju">
                <div style="margin-left: 20px;display:flex;justify-content: left;align-items: center;margin-top:9px;">
                  <div class="touxiang">
                    {{ getFirstName(jichu.userName) }}
                  </div>
                  <div>
                    <div>{{ jichu.userName }}</div>
                    <div style="display:flex;gap:20px;margin-top:15px;">
                      <div style="background-color: #f79e30;color:white;padding:5px;border-radius: 10px;">{{ jichu.degree
                      }}</div>
                      <div style="padding:5px;">{{ jichu.almaMater }}</div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 13px;display:flex;gap:20px;align-items: center;">
                  <span class="weibiaoti" style="margin-top: -1px;">专业</span>
                  <div style="padding:5px">{{ jichu.major }}</div>
                </div>
                <div style="margin-top: 13px;">
                  <span class="weibiaoti">证书</span>
                  <span>
                    <span v-for="(cert, index) in jichu.certificate" :key="index" class="fenhang">
                      {{ cert }}
                    </span>
                  </span>
                </div>
                <div>
                  <div class="weibiaoti">实习经历</div>
                  <span>
                    <span v-for="(ship, index) in jichu.internship" :key="index" class="fenhang">
                      {{ ship }}
                    </span>
                  </span>
                </div>
                <div class="juzhong">
                  <div class="selectinfo" @click="gotoQiyeReport">查看详情</div>
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="zhanshi = false">关闭</el-button>
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from 'vue';
import Footer from './Footer.vue'
import Header from './qiyeHeader.vue'
export default {
  name: 'cvscreening',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      // BASE_URL: 'http://192.168.2.8:8206',
      // BASE_URL3: 'http://192.168.2.8:8204',
      BASE_URL2: 'https://zhiyedashi.com/match',
      BASE_URL: 'https://zhiyedashi.com/info',
      BASE_URL3: 'https://zhiyedashi.com/job',
      qiyeId: sessionStorage.getItem("qiyeId"),
      shaixuan: '',
      displayData: [],
      tableData: [],
      currentPage: 1,
      pageSize: 8,
      total: 0,
      form: {
        applicants: [],
        jobs: [],
      },
      positions: [],
      zhanshi: false,
      jichu: {
        userName: "",
        degree: "",
        major: "",
        almaMater: "",
        certificate: [],
        internship: [],
      },
      options: [],
      value: "",
      loading: true,
      pipeiresult: [],
      isMobile: false
    }
  },
  created() {
    // 1. 判断关键数据是否存在
    if (!this.qiyeId) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.selectJobs()
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleStarChange(row) {
      const matchedApplicant = this.pipeiresult.find(
        item => item.applicant === row.userName
      );
      // console.log(matchedApplicant);
      const talentPool = {
        qiyeId: this.qiyeId,
        userId: row.userId,
        jobName: this.value,
        pipeiresult: JSON.stringify(matchedApplicant.dimension_wise_matching)
      }
      fetch(`${this.BASE_URL3}/admin/talent/savetalent`, {
        method: 'post',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(talentPool)
      })
        .then(res => res.json())
        .then(data => {
          // console.log("保存/修改成功", data);
          this.form.jobs = Array.of(this.value)
          this.selectJobs()
        })
        .catch(error => {
          console.error("保存修改失败，原因是", error)
        })
    },
    handleChange() {
      this.form.jobs = Array.of(this.value)
      localStorage.setItem("jobName", this.value);
      this.currentPage = 1
      localStorage.setItem("currentPage", this.currentPage);
      this.tuijian()
    },
    gotoQiyeReport() {
      localStorage.setItem("currentPage", this.currentPage);
      localStorage.setItem("jobName", this.value);
      this.$router.push('/qiyereport');
    },
    formatMatchLevel(row) {
      if (!row || row.matchLevel === undefined) {
        return '--'; // 默认值
      }
      // 如果是 "42.5/100" 这样的字符串，提取数值部分
      let value;
      if (typeof row.matchLevel === 'string' && row.matchLevel.includes('/')) {
        const parts = row.matchLevel.split('/');
        if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
          const numerator = parseFloat(parts[0]);
          const denominator = parseFloat(parts[1]);
          value = denominator !== 0 ? (numerator / denominator) * 100 : 0;
        } else {
          return '--'; // 格式无效
        }
      } else if (!isNaN(row.matchLevel)) {
        // 如果是数字或数字字符串（如 42.5 或 "42.5"）
        value = parseFloat(row.matchLevel);
      } else {
        return '--'; // 类型不支持
      }
      // 保留 1 位小数并加上 %
      return `${value.toFixed(1)}%`;
      // 先对整个 tableData 进行排序，然后再 slice
    },
    selectJobs() {
      fetch(`${this.BASE_URL3}/admin/qiyejob/selectJobName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `qiyeId=${this.qiyeId}`,
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log("1:查询岗位", data);
          if (data.data !== '没有数据') {
            this.options = data.data.map((item, index) => ({
              value: item,
              label: item
            }));
            if (localStorage.getItem("jobName") !== null) {
              this.value = localStorage.getItem("jobName")
            } else {
              this.value = this.options[0].value;
            }
            this.form.jobs = Array.of(this.value)
            this.tuijian()
          }
        })
        .catch((error) => {
          console.error("查询职业失败,原因是", error);
        })
    },
    pipei() {
      this.form.applicants = this.tableData.map(row => {
        return {
          applicant: row.userName,
          education: row.degree,
          major: row.major,
          school_rank: row.ranking,
          certificates: JSON.parse(row.certificate || '[]'),
          intern_experience: JSON.parse(row.internship),
          holland_result: row.result,
          expected_salary: "8000-10000",
        }
      })
      this.zhiyepipeidu()
    },
    zhiyepipeidu() {
      fetch(`${this.BASE_URL3}/admin/proxy`, {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `targetUrl=${this.BASE_URL2}&textent=${JSON.stringify(this.form)}`,
      })
        .then((res) => res.json())
        .then((data) => {
          // 为displayData中的每一行数据添加comprehensive_matching_score
          localStorage.setItem("pipeiresult", JSON.stringify(data.results));
          this.pipeiresult = data.results
          if (Array.isArray(data.results)) {
            this.tableData.forEach(row => {
              const matchedItem = data.results.find(item => item.applicant === row.userName);
              if (matchedItem && matchedItem.Comprehensive_matching_score !== undefined) {
                Vue.set(row, 'matchLevel', matchedItem.Comprehensive_matching_score);
              } else {
                Vue.set(row, 'matchLevel', '--');
              }
            });
            this.updateDisplayData()
          } else {
            console.error('data.results is not an array:', data.results);
          }
        })
        .catch((error) => {
          console.error("匹配职业失败，原因是", error);
        });
    },
    // zhiyepipeidu() {
    //   fetch(`${this.BASE_URL2}`, {
    //     method: "post",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(this.form),
    //   })
    //     .then((res) => res.json())
    //     .then((data) => {
    //       // console.log("3", data);
    //       localStorage.setItem("pipeiresult", JSON.stringify(data.results));
    //       // 为displayData中的每一行数据添加comprehensive_matching_score
    //       if (Array.isArray(data.results)) {
    //         this.tableData.forEach(row => {
    //           const matchedItem = data.results.find(item => item.applicant === row.userName);
    //           if (matchedItem && matchedItem.Comprehensive_matching_score !== undefined) {
    //             Vue.set(row, 'matchLevel', matchedItem.Comprehensive_matching_score);
    //           } else {
    //             Vue.set(row, 'matchLevel', '--');
    //           }
    //         });
    //       } else {
    //         console.error('data.results is not an array:', data.results);
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("匹配职业失败，原因是", error);
    //     });
    // },
    handleSizeChange(val) {
      this.pageSize = val;
      this.updateDisplayData();
    },
    // 切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      localStorage.setItem("currentPage", val);
      this.updateDisplayData();
    },
    // 更新当前页显示的数据
    updateDisplayData() {
      if (localStorage.getItem("currentPage") !== null) {
        this.currentPage = Number(localStorage.getItem("currentPage"))
      }
      const start = (this.currentPage - 1) * this.pageSize;

      const processedData = this.tableData.map(item => {
        const score = parseFloat(item.matchLevel.split('/')[0]);

        return {
          ...item,
          _sortScore: isNaN(score) ? 0 : score
        };
      });

      const sortedData = [...processedData].sort((a, b) =>
        b._sortScore - a._sortScore
      );

      this.loading = false

      this.displayData = sortedData.slice(start, start + this.pageSize);
    },
    formatDate(row, column, cellValue) {
      if (!cellValue) return '';
      return cellValue.split(' ')[0];
    },
    getFirstName(name) {
      if (!name) return '？';
      return name.charAt(0);
    },
    calculateAge(birthday) {
      const birthDate = new Date(birthday);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    tuijian() {
      fetch(`${this.BASE_URL}/admin/resumes/recommend`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `qiyeId=${this.qiyeId}&jobName=${this.value}`,
      })
        .then(res => res.json())
        .then(data => {
          // console.log("2:获取用户", data);
          this.tableData = data.data
          this.total = this.tableData.length
          this.pipei();
        })
        .catch(error => {
          console.error("推荐人才报错，原因是", error)
        });
    },
    handleClick(row) {
      this.zhanshi = true
      const newRow = JSON.parse(JSON.stringify(row));
      sessionStorage.setItem("linshiUserId", row.userId);
      localStorage.setItem("star", row.star);
      this.jichu = newRow;
      this.jichu.certificate = JSON.parse(row.certificate)
      this.jichu.internship = JSON.parse(row.internship)
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}
</script>

<style>
.el-dialog {
  width: 50% !important;
}

@media (max-width: 768px) {
  .el-dialog {
    width: 97% !important;
  }
}
</style>

<style scoped>
.liebiao {
  background-color: white;
  width: 10%;
  height: 95vh;
  border-radius: 50px;
  z-index: 10;
}

.beijing {
  background-color: #5c8bfd;
  width: 85%;
  height: 95vh;
  border-radius: 50px;
  margin-left: -90px;
}

.hengtiao {
  height: 50px;
  border-bottom: 1px solid white;
  display: flex;
  justify-content: right;
  align-items: center;
  margin-right: 30px;
  color: white;
  gap: 15px;
}

.hengtiao3 {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.hengtiao1 {
  background-color: rgb(245, 244, 244);
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
  color: #5c8bfd;
  gap: 15px;
  font-size: 22px;
  font-weight: 800;
  width: 100%;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
}

.juzhong {
  display: flex;
  justify-content: center;
  align-items: center;
}

.head01 {
  margin-left: 140px;
}

.head02 {
  color: white;
  font-size: 26px;
  margin-left: -170px;
}

.head03 {
  margin-top: 30px;
}

.sousuo {
  height: 40px;
  background-color: #759dfb;
  color: white;
  width: 60px;
  margin-left: 20px;
  text-align: center;
  border-radius: 10px;
  line-height: 40px;
}

:deep(.el-table__body) {
  -webkit-border-vertical-spacing: 35px;
}

.weibiaoti {
  font-weight: 700;
  padding: 2px;
  border-radius: 3px;
  margin-left: 13px;
  margin-top: 9px;
}

.jineng {
  padding: 3px;
  background-color: #f79e30;
  color: white;
  border-radius: 6px;
  margin-top: 15px;
  margin-left: 20px;
}

.shuju {
  height: 508px;
  width: 320px;
  background-color: white;
  border-radius: 20px;
  margin-left: 30px;
  text-align: left;
  margin-top: 30px;
}

.xuanzhong {
  font-size: 22px;
  margin-left: 20px;
  margin-top: 20px;
  font-weight: 700;
}

.fenhang {
  color: #f79e30;
  border: 1px solid #f79e30;
  padding: 2px 5px;
  border-radius: 5px;
  margin-right: 5px;
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 20px;
}

.touxiang {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #409EFF;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin-right: 10px;
}

.selectinfo {
  padding: 8px 16px;
  border: 1px solid #bfc3ce;
  border-radius: 20px;
  margin-top: 30px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .juzhong {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .head01 {
    margin-left: 0px;
    padding: 10px;
  }

  .head02 {
    color: black;
    margin-left: 0px;
    text-align: center;
    margin-bottom: 10px;
  }

  .head03 {
    margin-top: 10px;
    width: 100%;
  }

  .kuan {
    width: 100%;
  }

  .logo {
    width: 50px;
  }

  .xiangji {
    margin-left: 20px;
    font-weight: 800;
    font-size: 28px;
  }

  .gerenxinxi {
    margin-left: 20px;
    font-weight: 700;
  }

  .beijing {
    background-color: white;
    width: 100%;
    margin-left: 0;
    height: auto;
    padding-top: 140px;
  }

  .hengtiao3 {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
  }

  .sousuo {
    width: 50px;
    font-size: 14px;
  }

  .jineng {
    padding: 5px;
    font-size: 14px;
  }

  .shuju {
    width: 100%;
    height: auto;
    margin-left: 0;
  }

  .xuanzhong {
    font-size: 18px;
    margin-left: 10px;
  }

  .fenhang {
    font-size: 14px;
    margin-left: 10px;
  }

  .touxiang {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .selectinfo {
    padding: 8px 12px;
    font-size: 14px;
  }

  .el-dialog__body {
    padding: 0px 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cvscreening.vue